import { WalletContext } from "./context";

export const WalletProvider = ({ children }) => {
  const resetQueryParams = () => {
    window.history.pushState(null, null, window.location.pathname);
  };

  const contextValue = {
    resetQueryParams,
  };
  return (
    <WalletContext.Provider value={contextValue}>
      {children}
    </WalletContext.Provider>
  );
};
